import React from 'react';
import { Box, BoxProps, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { Close } from '@mui/icons-material';

type CloseButtonProps = {
  onClick?: () => void;
} & BoxProps;

export const CloseButton = ({ onClick = () => {}, sx = {}, ...rest }: CloseButtonProps) => {
  const theme = useTheme();
  const down_sm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ position: 'absolute', display: 'flex', top: 16, right: down_sm ? 12 : 16, ...sx }} {...rest}>
      <IconButton color="primary" onClick={onClick}>
        <Close />
      </IconButton>
    </Box>
  );
};
